<template>
  <v-row
    class="full-area pa-0 ma-0"
    v-bind:style="{
      backgroundImage: 'url(' + site.bg_url + ')',
      backgroundColor: site.color,
    }"
    style="
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    "
  >
    <div style="position: absolute; right: 10px; top: 10px; z-index: 1">
      <SelectLangauge />
    </div>

    <v-col cols="12" class="d-flex align-center justify-center">
      <v-card
        class="rounded-xl"
        elevation="10"
        style="width: 100%; max-width: 420px"
      >
        <v-container>
          <div class="pa-7 pa-sm-12">
            <v-row no-gutters>
              <v-col cols="12">
                <div>
                  <v-col class="d-flex justify-center mb-0">
                    <v-img
                      max-height="160"
                      max-width="225"
                      :src="site.logo_url"
                    ></v-img>
                  </v-col>
                  <h2
                    v-if="site.is_can_login == 'Y'"
                    class="mt-6 mb-2 blue-grey--text text--darken-2 text-letf"
                  >
                    {{ $t("welcome") }}
                  </h2>
                </div>

                <v-window
                  touchless
                  v-model="step"
                  v-if="site.is_can_login == 'Y'"
                >
                  <v-window-item :value="1">
                    <v-form
                      ref="formRegister"
                      v-model="valid"
                      lazy-validation
                      class="justify-center"
                      @submit.prevent="checkUserIsExit"
                    >
                      <v-col class="pa-0">
                        <div>
                          <v-row>
                            <!-- ========== ========== Line ========== ========== -->
                            <v-col
                              class="justify-center pb-0"
                              cols="12"
                              style="width: 100%"
                            >
                              <a
                                href="/login-line"
                                style="text-decoration: none"
                              >
                                <v-btn
                                  v-if="site.is_use_line != 'N'"
                                  class="py-2 social-btn"
                                  elevation="0"
                                  color="white"
                                  raised
                                >
                                  <img
                                    class="mr-2"
                                    width="22px"
                                    height="22px"
                                    src="@/assets/social/line-circle.svg"
                                  />
                                  {{ $t("signinWithLine") }}
                                </v-btn>
                              </a>
                            </v-col>

                            <!-- ========== ========== Google ========== ========== -->
                            <v-col class="justify-center" cols="12">
                              <v-btn
                                v-if="site.is_use_google != 'N'"
                                @click="handleGoogleLogin()"
                                class="social-btn"
                                elevation="0"
                                color="white"
                                raised
                              >
                                <img
                                  class="mr-2"
                                  width="22px"
                                  height="22px"
                                  src="@/assets/images/google.svg"
                                />
                                {{ $t("signinWithGoogle") }}
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-row
                            class="mb-4"
                            v-if="
                              site.is_use_google != 'N' &&
                              site.is_use_phone == 'Y'
                            "
                          >
                            <v-col
                              class="d-flex justify-center align-center py-1"
                            >
                              <v-divider class="mr-2"></v-divider>
                              <span class="grey--text">{{ $t("or") }}</span>
                              <v-divider class="ml-2"></v-divider>
                            </v-col>
                          </v-row>
                        </div>

                        <!-- ========== ========== Phone ========== ========== -->
                        <template v-if="key_login_type == 'phone'">
                          <v-text-field
                            v-if="site.is_use_phone == 'Y'"
                            :color="site.color"
                            v-model="mobile"
                            :rules="phoneRules"
                            :placeholder="$t('phone')"
                            class="rounded-lg"
                            maxlength="15"
                            type="number"
                            oninput="this.value=this.value.slice(0,this.maxLength)"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                        <!-- ========== ========== Email ========== ========== -->
                        <template v-if="key_login_type == 'email'">
                          <v-text-field
                            v-if="site.is_use_phone == 'Y'"
                            :color="site.color"
                            v-model="email"
                            :rules="emailRules"
                            :placeholder="$t('email')"
                            class="rounded-lg"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                      </v-col>

                      <!-- ========== ========== Button ========== ========== -->
                      <v-col
                        v-if="site.is_use_phone == 'Y'"
                        class="text-center pt-0"
                      >
                        <v-btn
                          class="text-center white--text rounded-lg"
                          :disabled="!valid"
                          :color="site.color"
                          @click="checkUserIsExit()"
                        >
                          {{ $t("confirm") }}
                        </v-btn>
                      </v-col>
                    </v-form>
                  </v-window-item>
                  <v-window-item :value="2">
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      class="justify-center"
                    >
                      <h4 class="mt-4 blue-grey--text text--darken-2">
                        {{ $t("sendRefCodeOtp") }} : {{ ref_code }}
                      </h4>
                      <v-col
                        class="ma-auto position-relative px-0"
                        style="max-width: 250px"
                      >
                        <v-otp-input
                          :color="site.color"
                          v-model="OTP"
                          :rules="otpRules"
                          length="6"
                          type="number"
                          required
                          outlined
                          :disabled="loading"
                          @finish="checkOTP"
                        ></v-otp-input>
                      </v-col>
                      <p class="text-caption mb-2">
                        {{ $t("textRequireOTPAgain") }}
                        {{ formattedTimeLeft }}
                      </p>
                      <v-btn
                        x-small
                        text
                        color="red"
                        class="text-center pa-0 mb-2"
                        @click="sendOTP"
                        :disabled="disableBtnOTP"
                      >
                        {{ $t("requestOtpAgain") }}
                        <v-icon x-small> mdi-sync </v-icon>
                      </v-btn>
                      <v-col class="text-center pa-1">
                        <v-btn
                          class="text-center white--text rounded-lg"
                          :disabled="!valid"
                          :color="site.color"
                          @click="checkOTP"
                        >
                          {{ $t("confirm") }}</v-btn
                        >
                      </v-col>
                    </v-form>
                  </v-window-item>
                </v-window>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <v-divider
          v-if="site.is_can_register == 'Y' && site.campaign_can_register"
        ></v-divider>

        <v-card-actions
          class="text-center d-flex justify-center my-2"
          v-if="site.is_can_register == 'Y' && site.campaign_can_register"
        >
          {{ $t("textFirstRegistration") }} ?
          <p
            class="ma-0 ml-5 text-decoration-underline"
            style="color: #1e88e5; cursor: pointer"
            @click="redirectRegister"
          >
            {{ $t("textClickHere") }}
          </p>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth } from "../../../config/firebaseAuth";
import Axios from "@/config/customer-service";
import SelectLangauge from "../../../components/selectLangauge.vue";
import { getLandingPage } from "../../../config/general-function.js";

export default {
  components: { SelectLangauge },
  inject: ["isAppLoading"],
  data: () => ({
    valid: true,
    loading: false,
    mobile: "",
    step: 1,
    OTP: "",
    request_id: "",
    ref_code: "",
    TIME_LIMIT: 60,
    timePassed: 0,
    timerInterval: null,
    disableBtnOTP: true,
    key_login_type: "phone",
    email: "",
  }),
  created() {},
  methods: {
    async handleGoogleLogin() {
      const provider = await new GoogleAuthProvider();
      console.log("provider :>> ", provider);
      return signInWithPopup(auth, provider)
        .then((result) => {
          this.$store.commit(
            "defaultSystem/SET_GOOGLE_USER",
            result.user.reloadUserInfo
          );
          this.checkEmailIsExist(result.user.reloadUserInfo.email);
        })
        .catch((error) => {
          console.log("error :>> ", error);
        });
    },
    checkEmailIsExist(email) {
      this.isAppLoading(true);
      Axios.get("checkUserIsRegisteredGoogle?email=" + email)
        .then((res) => {
          console.log("res :>> ", res);
          if (res.data.status == "registered") {
            localStorage.setItem("token", res.data.data.access_token);

            setTimeout(() => {
              if (this.urlRedirect) {
                this.$router.push({
                  path: this.urlRedirect,
                });
              }
              // ========== ========== Redirect & Reload ========== ==========
              const landing_page = getLandingPage();
              const targetRoute = this.$router.resolve({
                name: landing_page,
              });
              window.location.href = targetRoute.href;
              return;
            }, 1000);
          }
          if (res.data.status == "not_registered") {
            this.$router.push({ name: "checknumberGoogle" });
          }

          if (res.data.status == "unauthorized") {
            this.$router.push({ name: "checknumberGoogle" });
          }
        })
        .catch((err) => {
          console.log("err :>> ", err);
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    handleLineLogin() {
      this.$router.push({ name: "login-line" });
    },

    checkUserIsExit() {
      if (!this.$refs.formRegister.validate(true)) {
        return;
      }
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      let url =
        process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
        `/checkUserIsExist?mobile=${this.mobile}`;
      if (this.key_login_type == "email") {
        url =
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
          `/checkUserIsExist?email=${this.email}`;
      }
      axios
        .get(url)
        .then((res) => {
          if (res.data.status == "success") {
            this.site.is_login_bypass == "N"
              ? this.sendOTP()
              : this.loginWithOutOtp();
          } else if (res.data.status == "not_found") {
            this.$swal.fire({
              icon: "error",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else if (res.data.status == "not_registered") {
            localStorage.setItem("mobile", this.mobile);
            this.redirectRegister();
          } else {
            this.$swal.fire({
              icon: "error",
              text: res.data.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    loginWithOutOtp() {
      this.loading = true;
      this.$store.commit("login/SET_MOBILE", { mobile: this.mobile });
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      let body = {
        mobile: this.mobile,
      };
      if (this.key_login_type == "email") {
        body = {
          email: this.email,
        };
      }
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/loginWithOutOtp`,
          body
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$store.commit("defaultSystem/SET_USER", { role: "Customer" });
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                text: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (this.getUrlRedirect) {
                  this.$router.push({ path: this.getUrlRedirect });
                  return;
                }
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          } else {
            this.$swal
              .fire({
                icon: "info",
                html: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonColor: this.site.color,
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.confirmLogin();
                }
              });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    confirmLogin() {
      this.loading = true;
      this.$store.commit("login/SET_MOBILE", { mobile: this.mobile });
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/confirmLoginWithOutOtp`,
          {
            mobile: this.mobile,
          }
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$store.commit("defaultSystem/SET_USER", { role: "Customer" });
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (this.getUrlRedirect) {
                  this.$router.push({ path: this.getUrlRedirect });
                  return;
                }
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          } else {
            this.$swal
              .fire({
                icon: "info",
                html: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonColor: this.site.color,
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
              })
              .then((result) => {
                if (result.isConfirmed) {
                  this.confirmLogin();
                }
              });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    checkOTP() {
      if (!this.$refs.form.validate(true)) {
        return;
      }

      this.loading = true;
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/login`, {
          request_id: this.request_id,
          code: this.OTP,
          mobile: this.mobile,
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                text: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          }
        })
        .catch((err) => {
          this.OTP = "";
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    async setToken(accessToken) {
      return new Promise((resolve) => {
        localStorage.setItem("token", accessToken);
        resolve();
      });
    },
    sendOTP() {
      this.isAppLoading(true);
      if (!this.$refs.formRegister.validate(true)) {
        this.isAppLoading(false);
        return;
      }
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/sendOtp?mobile=${this.mobile}`
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.step = 2;
            this.request_id = res.data.data.request_id;
            this.ref_code = res.data.data.ref_code;
            this.$store.commit("login/SET_MOBILE", { mobile: this.mobile });
            this.timePassed = 0;
            this.timerInterval = null;
            this.disableBtnOTP = true;
            this.startTimer();
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    onTimesUp() {
      clearInterval(this.timerInterval);
    },
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    redirectLineLogin() {
      window.open(this.site.url + "/login-line");
    },
    redirectRegister() {
      if (this.site?.register_detail) {
        let target = this.site?.register_detail.is_blank ? "_blank" : "_self";
        if (
          this.site?.register_detail.url !== null &&
          this.site?.register_detail.is_source_external == true
        ) {
          window.open(this.site?.register_detail.url, target);
        } else {
          this.isAppLoading(true);
          this.$router
            .push({
              name: "register-bypass",
            })
            .then(() => {
              this.isAppLoading(false);
            });
        }
      } else {
        this.isAppLoading(true);
        this.$router
          .push({
            name: "register-bypass",
          })
          .then(() => {
            this.isAppLoading(false);
          });
      }
    },
  },
  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
        this.disableBtnOTP = false;
      }
    },
  },
  mounted() {
    // // ชั่วคราวๆ ให้เป็นภาษาไทย
    // this.$store.commit("defaultSystem/SET_LANGUAGE", "th");
  },

  computed: {
    ...mapState("defaultSystem", ["site"]),
    ...mapState("login", ["urlRedirect"]),
    phoneRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        // (v) =>
        //   /^(08|06|09)\d{8}$/.test(v) || this.$t("validation.phoneInvalid"),
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("validation.emailInvalid"),
      ];
    },
    otpRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /^[0-9]/.test(v) || this.$t("validation.numberInvalid"),
      ];
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
    timeLeft() {
      return this.TIME_LIMIT - this.timePassed;
    },
    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
      return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}
.full-area {
  color: rgba(0, 0, 0, 0.87);
}

.position-relative {
  position: relative;
}
.social-btn {
  width: 100%;
  text-transform: none;
  border: 0.7px solid grey !important;
  height: 40px;
  justify-content: left;
  font-family: sans-serif !important;
}
</style>
